export const values = [
    {
        "title": "Altruism",
        "description": "We care about the happiness of the other human beings.",
    },{
        "title": "Initiative",
        "description": "We value the ability to assess and initiate things independently.",
    },{
        "title": "Teamwork",
        "description": "We like to work effectively and efficiently in groups.",
    },{
        "title": "Respect",
        "description": "Show honor and good manners to someone regardless of anything.",
    },{
        "title": "Kindness and Empathy",
        "description": "It is important to understand and share the feelings of another by being friendly, generous, and considerate",
    },{
        "title": "Global Optimization",
        "description": "TechOpps do what’s best for the organization overall.",
    }
]